import { UserSettingsActions } from '../../userSettings/services/UserSettingsActions';
import { SessionManagementService } from '../../sessionManagement/SessionManagementService';
import { getAuthenticationServiceInstance } from '../../authentication/services/AuthenticationService';

export class UserActions {


  public signout() {
    getAuthenticationServiceInstance().signOut();
  }

  public changeUserStartPage() {
    UserSettingsActions.confirmChangeUserStartPage();
  }

  public changeServerDefaultStartPage() {
    UserSettingsActions.confirmChangeServerDefaultStartPage();
  }

  public changeSiteStartPage() {
    UserSettingsActions.confirmChangeSiteStartPage();
  }

}
